import React from "react";
import {
    Edit,
    SimpleForm,
    TextInput,
    Loading,
    Toolbar,
    SaveButton,
} from "react-admin";
import Grid from '@material-ui/core/Grid';
import WithProps from "../../Custom/WithProps";
import { makeStyles } from '@material-ui/core/styles';
import { GoBack } from "../../Signet/util";


const useStyles = makeStyles({
    container: {
        width: '100%',
    },
});

const EditToolBarWithoutDelete = (props) => {
    return (
        <Toolbar {...props}>
            <SaveButton />
            <GoBack />
        </Toolbar>
    );
};

const InlayEdit = props => {
    const classes = useStyles();
    const { permissions } = props;

    if (!permissions) return <Loading />;

    return (
        <Edit {...props} className='overflow-visible'>
            <WithProps>
                {({ record, ...props }) =>
                (<SimpleForm record={record} {...props} undoable={false} toolbar={<EditToolBarWithoutDelete />}>
                    <Grid container className={classes.container} justify="space-between">
                        <Grid item xs={5}>
                            <TextInput
                                source="name" label="Name" fullWidth disabled />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput
                                source="sku_code" label="Sku Code" fullWidth disabled />
                        </Grid>

                        <Grid item xs={5}>
                            <TextInput
                                source="netsuite_id" label="Netsuite ID" fullWidth />
                        </Grid>

                        <Grid item xs={5}>
                            <TextInput
                                source="netsuite_inlay_type" label="Netsuite Inlay Type" fullWidth />
                        </Grid>

                        <Grid item xs={5}>
                            <TextInput
                                source="netsuite_inlay_group" label="Netsuite Inlay Group" fullWidth />
                        </Grid>
                    </Grid>
                </SimpleForm>)
                }
            </WithProps>
        </Edit>
    )
};

export default InlayEdit;

